module.exports = __webpack_public_path__ + "img/log.7576d261.png";